import bn from '@/utils/bn'

export const KATINRUN_ADDRESS = '0xd45db64bcdbdc42cab08eef8e848acca1ef76481'
export const BIGNUMBER_ZERO = bn(0)
